import React, { useState } from "react";
import { Field, FieldArray } from "formik";
import { yesNoOptions, returnOnlyIfBoolean } from "../../../utils";
import {
  FieldButtonGroup,
  CsplTable as Table,
  FieldInput,
  FieldInputNumber,
  FieldInputPercentage,
  FieldInputDollar,
} from "../../../components";
import { get, isEmpty } from "lodash";
import { Form } from "react-bootstrap";

export const DeferralElection = (props) => {
  const {
    fields,
    isSave,
    isEdit,
    values,
    setFieldValue,
    handleChange,
    sourcesList,
    getDefaultElection,
    autoEnrollment,
  } = props;
  const [savedResponses, setSavedResponses] = useState({});
  const displayType = (amt, cont, number) => {
    let res;
    if (cont === 2)
      res =
        number === 0
          ? "Minimum amount " + "$" + amt
          : "Maximum amount " + "$" + amt;
    else
      res =
        number === 0
          ? "Minimum percentage " + amt + "%"
          : "Maximum percentage " + amt + "%";
    return res;
  };

  return (
    <div>
      <Field
        isRequired
        name={`autoEnrollment.${fields.usePlanDefaultDeferralElection}`}
        label="Use plan default deferral election"
        size="sm"
        options={yesNoOptions}
        selectedValue={returnOnlyIfBoolean(
          get(values.autoEnrollment, fields.usePlanDefaultDeferralElection)
        )}
        onChange={(value) => {
          setFieldValue(
            `autoEnrollment.${fields.usePlanDefaultDeferralElection}`,
            value
          );
          if (!value) {
            sourcesList?.map((e, i) => {
              setFieldValue(
                `autoEnrollment.autoEnrollmentDeferralSources.${i}`,
                null
              );
            });
          }
        }}
        disabled={isEdit && !isSave}
        component={FieldButtonGroup}
      />
      {get(values.autoEnrollment, fields.usePlanDefaultDeferralElection) ===
      false ? (
        <FieldArray name="sourcesList">
          {(fieldArrayProps) => {
            return (
              <Table.Tbody>
                {sourcesList &&
                  sourcesList.map((e, i) => {
                    const toggleSavedResponseChecked = (id) => {
                      setSavedResponses((savedResponses) => ({
                        ...savedResponses,
                        [id]: savedResponses[id]
                          ? {
                              ...savedResponses[id],
                              checked: [savedResponses[id]?.checked]
                                ? false
                                : true,
                            }
                          : {
                              sourceId: id,
                              checked: true,
                            },
                      }));
                    };
                    const fieldName = `autoEnrollment.autoEnrollmentDeferralSources[${i}].deferralSourcePercentage`;
                    const checkBoxName = `autoEnrollment.autoEnrollmentDeferralSources[${i}].excludeFromEnrollment`;
                    //const sourceName= `autoEnrollmentDeferralSources[${i}].deferralSourceName`;

                    const AddName = (x, source) => {
                      //values.autoEnrollmentDeferralSources=values.autoEnrollmentDeferralSources.map(obj=> ({ ...obj[i], deferralSourceName:source }))

                      setFieldValue(
                        `autoEnrollment.autoEnrollmentDeferralSources.${i}`,
                        {
                          ...get(
                            values,
                            `autoEnrollment.autoEnrollmentDeferralSources.${i}`,
                            {}
                          ),
                          deferralSourceName: source.sourceName,
                          limitMaximumDollar: source.maximumRate,
                          limitMinimumDollar: source.minimumRate,
                          sourceId: source.sourceId,
                        }
                      );
                      //   values.autoEnrollment.autoEnrollmentDeferralSources[
                      //     i
                      //   ].deferralSourceName = source.sourceName;
                      //   values.autoEnrollment.autoEnrollmentDeferralSources[
                      //     i
                      //   ].limitMaximumDollar = source.limitMaximumDollar;
                      //   values.autoEnrollment.autoEnrollmentDeferralSources[
                      //     i
                      //   ].limitMinimumDollar = source.limitMinimumDollar;
                      //   values.autoEnrollment.autoEnrollmentDeferralSources[
                      //     i
                      //   ].sourceId = source.id;

                      handleChange(x);
                    };

                    return (
                      <div key={i} className="d-flex">
                        <Field
                          size="xs"
                          isRequired
                          name={fieldName}
                          label={e.sourceName}
                          hasSuggestion
                          suggestionDefaultText={`${displayType(
                            e.minimumRate,
                            e.contributionType,
                            0
                          )} / ${displayType(
                            e.maximumRate,
                            e.contributionType,
                            1
                          )}`}
                          shouldDisplaySuggestion
                          component={
                            e.contributionType === 2
                              ? FieldInputDollar
                              : FieldInputPercentage
                          }
                          type="number"
                          autoComplete="off"
                          defaultValue={parseInt(get(values, fieldName))}
                          max={e.contributionType === 2 ? 99999999999 : 99}
                          min={0}
                          onChange={(x) => {
                            AddName(x, e);
                          }}
                          disabled={
                            (isEdit && !isSave) || get(values, checkBoxName)
                          }
                        />
                        &nbsp;&nbsp;&nbsp;
                        <div
                          style={{
                            paddingLeft: "20px",
                          }}
                        ></div>
                        <Form.Check
                          custom
                          name={checkBoxName}
                          type="checkbox"
                          id={checkBoxName}
                          value={get(values, checkBoxName)}
                          onChange={handleChange}
                          checked={get(values, checkBoxName)}
                          disabled={isEdit && !isSave}
                        />
                        &nbsp;&nbsp;&nbsp;
                        <div
                          style={{
                            //marginBottom: "-4rem",
                            fontSize: "13px",
                            paddingTop: "40px",
                            //paddingLeft:"20px"
                          }}
                          //size="xs"
                        >
                          Exclude from Enrollment
                        </div>
                      </div>
                    );
                  })}
              </Table.Tbody>
            );
          }}
        </FieldArray>
      ) : null}
      {get(values.autoEnrollment, fields.usePlanDefaultDeferralElection) ===
      true ? (
        <FieldArray name="getDefaultElection">
          <>
            {getDefaultElection.deferralSourceContribution &&
              getDefaultElection.deferralSourceContribution.map((e, i) => {
                return (
                  <div key={i}>
                    <Field
                      size="xs"
                      isRequired
                      //name={"sourcename"}
                      label={get(e, "sourceName", "")}
                      value={get(e, "contributionRate", 0)}
                      disabled={true}
                      component={
                        get(e, "contributionType", 1) === 2
                          ? FieldInputDollar
                          : FieldInputPercentage
                      }
                      type="number"
                      autoComplete="off"
                    />
                  </div>
                );
              })}
          </>
        </FieldArray>
      ) : null}
    </div>
  );
};

export default DeferralElection;
